
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 15 16"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Ebene_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 15 16","style":"enable-background:new 0 0 15 16;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M11.5,4.5V3.8c0-2.1-1.8-3.8-4-3.8c-2.2,0-4,1.7-4,3.8v0.7h-3v11h14v-11H11.5z M4.5,3.8c0-1.5,1.3-2.8,3-2.8\n\ts3,1.3,3,2.8v0.7h-6V3.8z M13.5,14.5h-12v-9h2v2h1v-2h6v2h1v-2h2V14.5z"}})])
          )
        }
      }
    